function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "_x38__19_"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M569.811,137.206H316.674c-23.309,0-42.189,18.88-42.189,42.189s18.88,42.189,42.189,42.189h253.137 c23.289,0,42.189-18.88,42.189-42.189S593.12,137.206,569.811,137.206z M316.674,95.017h253.137 C593.1,95.017,612,76.137,612,52.827c0-23.289-18.9-42.189-42.189-42.189H316.674c-23.309,0-42.189,18.901-42.189,42.189 C274.485,76.137,293.386,95.017,316.674,95.017z M569.811,516.911H316.674c-23.309,0-42.189,18.88-42.189,42.189 s18.88,42.189,42.189,42.189h253.137c23.289,0,42.189-18.901,42.189-42.189C612,535.812,593.12,516.911,569.811,516.911z  M331.166,396.734c-8.27-8.312-14.492-6.392-14.492-6.392H190.106V10.638h-42.189v379.705H21.348c0,0-6.876-1.92-15.146,6.392 c-8.269,8.312-8.269,21.77,0,30.06l146.44,168.526c4.409,4.43,10.273,6.307,16.032,6.012c5.78,0.295,11.623-1.582,16.032-6.012 l146.438-168.526C339.436,418.504,339.436,405.046,331.166,396.734z M569.811,263.774H316.674 c-23.309,0-42.189,18.879-42.189,42.189c0,23.31,18.88,42.189,42.189,42.189h253.137c23.289,0,42.189-18.88,42.189-42.189 C612,282.654,593.12,263.774,569.811,263.774z M569.811,390.343H443.242c-23.31,0-42.189,18.88-42.189,42.189 c0,23.288,18.88,42.189,42.189,42.189h126.568c23.289,0,42.189-18.88,42.189-42.189S593.12,390.343,569.811,390.343z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgSortDown(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "612px",
    height: "612px",
    viewBox: "0 0 612 612",
    style: {
      enableBackground: "new 0 0 612 612"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDown);
export default __webpack_public_path__ + "static/media/sort-down.0d0916eb.svg";
export { ForwardRef as ReactComponent };